import { call, put } from 'redux-saga/effects';

import {
  loadNotifications,
  setNotificationsMessagesSeen,
  setNotificationsMessagesUnread,
} from '../actions/notificationMessageAction';
import Services from '../services/index';

export function* getNotificationMessageSaga(action) {
  try {
    const response = yield call(
      Services.NotificationMessageService.getNotificationMessagesService,
      action.userId,
    );
    yield put(setNotificationsMessagesUnread(response.notificationsUnread));
    yield put(setNotificationsMessagesSeen(response.notificationsSeen));
  } catch (err) {}
}

export function* setNotificationMessageSeenSaga(action) {
  try {
    yield put(loadNotifications(true));
    yield call(
      Services.NotificationMessageService.setNotificationMessagesSeenService,
      action.notifications,
    );
  } catch (err) {
  } finally {
    yield put(loadNotifications(false));
  }
}
